module.exports = __webpack_public_path__ + "img/media-3.0002b417.png";